"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cta = void 0;
var _components = require("@ori-ui/components");
var _constants = require("../../constants");
var _jsxRuntime = require("react/jsx-runtime");
const Cta = ({
  hidden,
  ...props
}) => !hidden && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
  minWidth: _constants.CTA_MIN_WIDTH,
  maxWidth: _constants.CTA_MAX_WIDTH,
  hidden: hidden,
  ...props
});
exports.Cta = Cta;
